import { all } from "redux-saga/effects";
import { attributesSaga } from "./attributes/saga";
import { authSagas } from "./auth/saga";
import { callCenterSagas } from "./callcenter/saga";
import { createMenuSagas } from "./createMenu/saga";
import { locationsSaga } from "./locations/saga";
import { menusSaga } from "./menu/saga";
import { menusListSaga } from "./menulist/saga";
import { ordersSaga } from "./orders/saga";
import { stopListsSaga } from "./stoplist/saga";
import { settingsSaga } from "./settings/saga";
import { selectAllSaga } from "./selectAll/saga";
import { appManagerSagas } from "./app_manager/saga";
import { allAttributesListSectionSaga } from "@src/pages/ConfigureMenuPage/components/AttributesListSection/middleware/saga/allAttributesListSectionSaga";
import { ordersExcelSaga } from "./ordersExcel/saga";
export default function* rootSaga() {
  yield all([
    appManagerSagas(),
    ordersSaga(),
    locationsSaga(),
    menusListSaga(),
    menusSaga(),
    stopListsSaga(),
    createMenuSagas(),
    attributesSaga(),
    settingsSaga(),
    authSagas(),
    callCenterSagas(),
    selectAllSaga(),
    allAttributesListSectionSaga(),
    ordersExcelSaga(),
  ]);
}
